export const allocationAccountFields = ({
  data,
  values,
  selectActions,
  selectSingleIds,
  loadings,
  disabled,
}: {
  data: {
    states: any[];
    cities: any[];
    townships: any[];
    warehouseData: any;
  };
  values?: {
    state?: number | string;
    city?: number | string;
    township?: number | string;
    country?: number | string;
    selectedType?: number | string;
    warehouseValue?: number | string;
  };
  disabled: {
    cityDisabled: boolean;
    townshipDisabled: boolean;
    warehouseDisabled?: boolean;
  };
  loadings?: {
    stateLoading: boolean;
    cityLoading: boolean;
    townshipLoading: boolean;
  };
  selectActions: {
    stateAction: any;
    cityAction: any;
    townshipAction: any;
  };
  selectSingleIds: {
    stateId: number | string;
    townshipId: number | string;
    cityId: number | string;
  };
}) => {
  console.log(data?.townships, "data?.cities");
  return [
    {
      name: "warehouse_name",
      type: "text",
      label: "Allocation Account Name",
      required: true,
    },
    {
      name: "main_warehouse_id",
      title: "Main Warehouse Name List",
      columnName: "Warehouse Name",
      columns: [
        {
          name: "warehouse_name",
          columnName: "Warehouse Name",
        },
        {
          name: "warehouse_address",
          columnName: "Address",
        },
      ],
      idName: "warehouse_id",
      nameName: "warehouse_name",
      type: "search-modal-choose",
      label: "Main Warehouse Name ",
      placeHolder: "Choose Main Warehouse Name ",
      data: data?.warehouseData?.map((c: any) => ({
        warehouse_id: c.warehouse_id,
        warehouse_name: c.warehouse_name,
        warehouse_address: c.warehouse_address,
      })),
      value: values?.warehouseValue,
      hidden: values?.selectedType == 1 ? true : false,
      required: values?.selectedType == 2 ? true : false,
    },
    
    {
      name: "warehouse_phone1",
      type: "text",
      label: "Phone Number 1",
      required: true,
    },
    {
      name: "warehouse_phone2",
      type: "text",

      label: "Phone Number 2",
    },
    {
      name: "warehouse_phone3",
      type: "text",

      label: "Phone Number 3",
    },
   
    {
      name: "warehouse_email",
      type: "text",
      label: "Allocation Account Email",

      placeHolder: "Enter allocation account email",
    },
     {
      name: "contact_first_name",
      type: "text",
      label: "Contact Person First Name",

      placeHolder: "Enter first name",
    },
    {
      name: "contact_phoneno",
      type: "text",
      label: "Contact Person Phone Number",

      placeHolder: "Enter phone number",
    },
 
    // ...(values?.selectedType == '1' ? [
   
    // ]:[]),
    {
      name: "description",
      type: "textarea",
      colSpan: 6,
    },
  ];
};
